<!-- 兑换记录 -->
<template>
  <div class="component-page">
    <div class="filter">
      <div class="filter-left">
        <el-radio-group
          v-model="formParams.status"
          size="small"
          @input="methodChangeStatus"
        >
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="2">已兑换</el-radio-button>
          <el-radio-button :label="0">兑换中</el-radio-button>
          <el-radio-button :label="1">被驳回</el-radio-button>
        </el-radio-group>
      </div>
      <div class="filter-right">
        <el-date-picker
          v-model="formParams.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placement="bottom-start"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          @change="methodChangeDate"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="table">
      <el-table
        size="small"
        :data="tableData"
        :header-row-style="{
          'border-radius': '5px',
          overflow: 'hidden',
        }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'font-size': '14px',
        }"
        stripe
      >
        <el-table-column
          v-for="item in tableTitle"
          :key="item.value"
          :value="item.value"
          :label="item.label"
          :align="item.align"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="item.value === 'productCategory'">
              <span>
                {{ categoryMap[scope.row[item.value]] }}
              </span>
            </div>
            <div
              v-else-if="item.value === 'orderState'"
              style="display:flex;justify-content:center;align-items:center"
            >
              <i
                :style="{
                  display: 'inline-flex',
                  width: '5px',
                  height: '5px',
                  borderRadius: '50%',
                  marginRight: '5px',
                  backgroundColor:
                    scope.row.orderState === 0
                      ? '#2488ef'
                      : scope.row.orderState === 1
                      ? '#e4393c'
                      : '#17A81C',
                }"
              ></i>
              <span>
                {{ stateMap[scope.row[item.value]] }}
              </span>
            </div>
            <div v-else-if="item.value === 'operation'">
              <el-button
                type="text"
                size="mini"
                @click="methodExchangeDialog(scope.row)"
              >
                查看订单
              </el-button>
            </div>
            <div v-else>{{ scope.row[item.value] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹框 -->
    <el-dialog title="" :visible.sync="exchangeDialog" width="680px">
      <div class="exchange-info" v-if="exchangeInfo">
        <div class="left">
          <img :src="exchangeInfo.highPictureUrl" alt="" />
        </div>
        <div class="right">
          <div class="title">{{ exchangeInfo.productName }}</div>
          <div class="order">订单编号：{{ exchangeInfo.orderNumber }}</div>
          <div class="num">
            数量：{{ exchangeInfo.exchangeNum }}
            <!-- @change="handleChange" -->
          </div>
          <div class="type">
            商品类别：{{ categoryMap[exchangeInfo.productCategory] }}
          </div>
          <div class="price">
            单价：{{ exchangeInfo.starNum }} <span>星币</span>
          </div>
          <div class="reject" v-if="exchangeInfo.orderState === 1">
            <div>驳回原因：</div>
            <div>{{ exchangeInfo.rejectReason }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="exchangeInfo">
        <div class="practical">
          实际消耗：<span
            ><strong>{{ exchangeInfo.consumeStarNum }}</strong> 星币</span
          >
        </div>
        <!-- <el-button
          type="primary"
          @click="stuOrderExchange"
          v-if="exchangeInfo.orderState === 0"
          >立即兑换</el-button
        >
        <el-button
          type="primary"
          plain
          @click="exchangeDialog = false"
          v-else
          >{{ exchangeInfo.orderState === 1 ? '被驳回' : '已领取' }}</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 引入请求
import {
  api_stuOrderStuRedeemRecord,
  api_stuOrderExchange,
} from '@/api/javaApi'

export default {
  name: 'exchangeRecord',
  props: ['pageInfo'],
  data() {
    return {
      formParams: {
        status: null,
        date: null,
      },
      tableTitle: [
        { label: '订单编号', value: 'orderNumber' },
        { label: '时间', value: 'createTime' },
        { label: '商品信息', value: 'productName' },
        { label: '商品类型', value: 'productCategory' },
        { label: '数量', value: 'exchangeNum' },
        { label: '实付款', value: 'consumeStarNum' },
        { label: '订单状态', value: 'orderState', align: 'center' },
        { label: '操作', value: 'operation' },
      ],
      stateMap: {
        0: '兑换中',
        1: '已驳回',
        2: '已兑换',
      },
      categoryMap: {
        null: '全部',
        0: '伴学精灵',
        1: '头像挂件',
        2: '实物',
        3: '头像',
      },
      tableData: [],
      exchangeDialog: false,
      exchangeInfo: null,
    }
  },
  computed: {
    calcPageInfo() {
      return window.JSON.stringify(this.pageInfo)
    },
  },
  watch: {
    // 直接监听prop新旧值一样，因为是引用类型，所以用计算属性包裹一下变成字符串
    calcPageInfo: {
      handler(newPage, oldPage) {
        if (oldPage !== newPage && window.JSON.parse(newPage).update) {
          this.stuOrderStuRedeemRecord()
        }
      },
    },
  },
  created() {
    this.stuOrderStuRedeemRecord()
  },
  methods: {
    methodChangeStatus() {
      // 直接查询
      this.stuOrderStuRedeemRecord()
    },
    methodChangeDate(date) {
      console.log(date)
      this.$emit('returnPage', {
        currentPage: 1,
      })
      this.stuOrderStuRedeemRecord()
    },
    stuOrderStuRedeemRecord() {
      let startTime = null,
        endTime = null
      if (this.formParams.date) {
        startTime =
          this.formParams.date.length > 0 ? this.formParams.date[0] : null
        endTime =
          this.formParams.date.length > 0 ? this.formParams.date[1] : null
      }
      api_stuOrderStuRedeemRecord({
        stuId: this.$store.state.user.userInfo.id,
        state: this.formParams.status,
        startTime,
        endTime,
        pageRequest: {
          pageNum: this.pageInfo.currentPage,
          pageSize: this.pageInfo.pageSize,
        },
      }).then((res) => {
        console.log(res)
        res.content.forEach((item) => {
          item.highPictureUrl =
            this.$store.state.resource.picBaseUrl + item.highPictureUrl
        })
        this.tableData = res.content
        this.$emit('returnPage', {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
          update: false,
        })
      })
    },
    methodExchangeDialog(row) {
      this.exchangeInfo = row
      this.exchangeDialog = true
    },
    stuOrderExchange() {
      api_stuOrderExchange({
        productId: this.exchangeInfo.productId, // 产品ID
        exchangeNum: this.exchangeInfo.exchangeNum, // 兑换数量
        consumeStarNum: this.exchangeInfo.consumeStarNum, // 消耗星币
        productCategory: this.exchangeInfo.productCategory, // 产品类型
        eduCampusId: this.$store.state.user.userInfo.eduCampusId, // 学校ID
        stuId: this.$store.state.user.userInfo.id, // 学生ID
        stuName: this.$store.state.user.userInfo.stuUserInfo.realName, // 学员姓名
      }).then((res) => {
        console.log(res)
        this.$message.success(res)
        this.exchangeDialog = false
        this.stuOrderStuRedeemRecord()
      })
    },
  },
}
</script>
<style scoped lang="scss">
.component-page {
  padding: 20px 40px 40px;
  background-color: #fff;
  border-radius: 10px;
  .filter {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    .filter-left {
      .el-radio-group /deep/ {
        .el-radio-button.is-active {
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background-color: #fff;
            color: #409eff;
          }
        }
      }
    }
  }
  .el-dialog {
    .exchange-info {
      display: flex;
      padding: 0 20px 30px;
      border-bottom: 1px solid #f5f5f5;
      .left {
        flex-shrink: 0;
        width: 165px;
        height: 165px;
        margin-right: 25px;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .right {
        flex: 1;
        .title {
          padding-bottom: 10px;
          font-weight: 500;
          font-size: 16px;
          color: #0a1629;
        }
        .order {
          padding-bottom: 10px;
          font-weight: 400;
          font-size: 14px;
          color: #0a1629;
        }
        .price {
          padding-top: 20px;
          font-weight: 600;
          font-size: 18px;
          color: #1678ff;
          span {
            font-weight: 400;
            font-size: 14px;
          }
        }
        .num {
          font-weight: 400;
          font-size: 12px;
          color: #666666;
        }
        .type {
          padding-top: 15px;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
        }
        .reject {
          display: flex;
          padding-top: 10px;
          font-weight: 400;
          font-size: 12px;
          color: #fb5451;
          div:first-child {
            flex-shrink: 0;
          }
        }
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      .practical {
        display: inline-flex;
        align-items: center;
        margin-right: 40px;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
        span {
          color: #1678ff;
          strong {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
